import reactCookies from 'react-cookies';
import jwtDecode from 'jwt-decode';
//
import {
  init,
  invalidateStores,
  setToken,
  signIn,
  signOut,
} from '../../slice/auth.slice';
import { TOKEN_COOKIE } from '../../../constants';
import { baseApi } from '../../api/base.api';

export default function registerListeners(addListener) {
  addListener({
    matcher: init.match,
    effect: (action, api) => {
      const rawToken = reactCookies.load(TOKEN_COOKIE);
      if (!rawToken) {
        return;
      }
      try {
        // decoding in try-catch, so that token is set only if it's valid (at least, from JWT perspective)
        jwtDecode(rawToken);
        api.dispatch(setToken(rawToken));
      } catch (err) {
        console.warn("Found token in store, but it's invalid", err);
      }
    },
  });
  addListener({
    matcher: signIn.match,
    effect: (action) => {
      const token = action.payload;
      reactCookies.save(TOKEN_COOKIE, token, { path: '/' });
    },
  });
  addListener({
    matcher: signOut.match,
    effect: (action, api) => {
      reactCookies.remove(TOKEN_COOKIE, { path: '/' });
      api.dispatch(invalidateStores());
    },
  });
  // handler for 'soft' signOut (when auth error happens)
  // we don't remove token, only kick user back to login page
  addListener({
    matcher: setToken.match,
    effect: (action, api) => {
      if (!action.payload) {
        api.dispatch(invalidateStores());
      }
    },
  });
  addListener({
    matcher: invalidateStores.match,
    effect: (action, api) => {
      // resetting api state, so if next consequential login happens, fresh data is fetched
      api.dispatch(baseApi.util.resetApiState());
    },
  });
}
